export default "__VITE_ASSET__60d01bac__"